export default {
  about: {
    zh: '关于',
    en: 'About',
    ja: 'MQTTXについて',
  },
  update: {
    zh: '检查更新',
    en: 'Check for Updates',
    ja: 'バージョンチェック',
  },
  web: {
    zh: '官方网站',
    en: 'Website',
    ja: '公式サイト',
  },
  support: {
    zh: '支持',
    en: 'Support',
    ja: 'サポート',
  },
  dataCollectionPolicy: {
    zh: '数据收集政策',
    en: 'Data Collection Policy',
    ja: 'データ収集ポリシー',
  },
  releases: {
    zh: '更新日志',
    en: 'Releases',
    ja: 'リリース履歴',
  },
  mqttxDesc: {
    zh: 'MQTTX Web 是一款开源的可在浏览器运行的 MQTT 5.0 WebSocket 客户端工具，无需本地安装即可帮助您更快地调试 MQTT 服务及应用。',
    en: 'MQTTX Web is an open-source MQTT 5.0 WebSocket client on the browser to help you debug your MQTT services and applications faster.',
    ja: 'MQTTX Webは、オープンソースのMQTT 5.0 WebSocketクライアントで、ブラウザ上でMQTTサービスやアプリケーションのデバッグを高速化することができます。',
  },
  cloudTitle: {
    zh: '立即获取一个您专属的 MQTT 服务！',
    en: 'Get Your Dedicated MQTT Server Now!',
    ja: '専用のMQTTサーバーを今すぐご利用いただけます！',
  },
  cloudSummary: {
    zh: '发掘物联网的强大能量，尝试使用 EMQX Cloud - 一款全托管的 MQTT 云服务平台，支持连接海量设备，使用灵活按量计费的方式实时处理数据，将物联网连接和数据处理变得更高效便捷。',
    en: 'Unlock the power of IoT with EMQX Cloud - the fully managed MQTT cloud service platform that connects massive amounts of devices and processes real-time data with flexible pay-per-use billing.',
    ja: 'EMQX Cloudを使用してIoTの強力な機能を発見しましょう。EMQX Cloudは、大規模なデバイスを接続し、リアルタイムデータを柔軟な使用料金で処理することができる完全に管理されたMQTTクラウドサービスプラットフォームです。',
  },
  tryCloud: {
    zh: '免费试用 EMQX Cloud',
    en: 'Try EMQX Cloud for free',
    ja: 'EMQX Cloudの無料体験',
  },
  platformTitle: {
    zh: '统一的物联网 MQTT 平台',
    en: 'The Unified MQTT Platform for IoT',
    ja: 'IoT向け統合MQTTプラットフォーム',
  },
  platformDesc: {
    zh: '完整的生产级 MQTT 平台，无缝连接工业设备、边缘网关和云服务。从边缘协议桥接到超大规模云消息传递，统一在一个平台下管理您的整个物联网数据基础设施。',
    en: 'Connect everything, scale infinitely. One platform for industrial devices, edge gateways, and cloud services — powering your entire IoT infrastructure.',
    ja: '産業用デバイス、エッジゲートウェイ、クラウドサービスをシームレスに接続する、完全な本番環境対応MQTTプラットフォーム。',
  },
  statDownloads: {
    zh: '产品下载量',
    en: 'Product Downloads',
    ja: '製品ダウンロード数',
  },
  statClusters: {
    zh: '全球部署集群',
    en: 'Global Clusters',
    ja: 'グローバルクラスター',
  },
  statProtocols: {
    zh: '工业协议支持',
    en: 'Industrial Protocols',
    ja: '産業用プロトコル',
  },
  statLatency: {
    zh: '超低延迟',
    en: 'Ultra-Low Latency',
    ja: '超低遅延',
  },
  statConnections: {
    zh: '单集群并发连接',
    en: 'Connections/Cluster',
    ja: '接続数/クラスター',
  },
  tryPlatform: {
    zh: '立即免费试用',
    en: 'Start Free Trial',
    ja: '無料トライアルを開始',
  },
  signIn: {
    zh: '登录',
    en: 'Sign In',
    ja: 'サインイン',
  },
}
